import { render, staticRenderFns } from "./attachment-info.vue?vue&type=template&id=2a8f5ad0&scoped=true&"
import script from "./attachment-info.vue?vue&type=script&lang=js&"
export * from "./attachment-info.vue?vue&type=script&lang=js&"
import style0 from "./attachment-info.vue?vue&type=style&index=0&id=2a8f5ad0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f5ad0",
  null
  
)

export default component.exports